module.exports = function(gantt) {


};


//////////////////
// WEBPACK FOOTER
// ./sources/core/data_task_types.gpl.js
// module id = 82
// module chunks = 0